module.exports = __webpack_public_path__ + "img/button.57a95cea.png";